module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm_title"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("Organisational Tables")]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_vm._v("DIRECTORS OF GCHQ")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab2a"
  }, [_vm._v("Alastair Denniston")]), _vm._v(" "), _c('td', {
    staticClass: "tab3"
  }, [_vm._v("1921 – 44")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab2a"
  }, [_vm._v("Sir Edward Travis")]), _vm._v(" "), _c('td', {
    staticClass: "tab3"
  }, [_vm._v("1944 – 52")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab2a"
  }, [_vm._v("Sir Eric Jones")]), _vm._v(" "), _c('td', {
    staticClass: "tab3"
  }, [_vm._v("1952 – 60")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab2a"
  }, [_vm._v("Sir Clive Loehnis")]), _vm._v(" "), _c('td', {
    staticClass: "tab3"
  }, [_vm._v("1960 – 64")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab2a"
  }, [_vm._v("Sir Leonard Hooper")]), _vm._v(" "), _c('td', {
    staticClass: "tab3"
  }, [_vm._v("1965 – 73")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab2a"
  }, [_vm._v("Sir Arthur Bonsall")]), _vm._v(" "), _c('td', {
    staticClass: "tab3"
  }, [_vm._v("1973 – 78")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab2a"
  }, [_vm._v("Sir Brian Tovey")]), _vm._v(" "), _c('td', {
    staticClass: "tab3"
  }, [_vm._v("1978 – 83")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab2a"
  }, [_vm._v("Sir Peter Marychurch")]), _vm._v(" "), _c('td', {
    staticClass: "tab3"
  }, [_vm._v("1983 – 89")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "org"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("National Security Agency")])]), _vm._v(" "), _c('p', {
    staticClass: "org"
  }, [_vm._v("Fort George G Meade")]), _vm._v(" "), _c('p', {
    staticClass: "org"
  }, [_vm._v("Maryland")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26c8740b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Organisational.vue
// module id = 75
// module chunks = 0